
import React from 'react';
import { Button } from '@/components/ui/button';
import { LoaderCircle } from 'lucide-react';

interface LoadingButtonProps {
  onRetry: () => void;
}

const LoadingButton = ({ onRetry }: LoadingButtonProps) => {
  return (
    <Button variant="outline" size="sm" className="px-4 py-1.5" onClick={onRetry}>
      <LoaderCircle className="w-4 h-4 mr-2 animate-spin" />
      Loading...
    </Button>
  );
};

export default LoadingButton;
